import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AppLogo from "../AppLogo";
import { Link } from "react-router-dom";
import { useAuthSession } from "../AuthSessionProvider";
import { ConditionalRenderer } from "../conditionalRenderer";
import { CollapseNavbarIcon, CrossNavbarIcon } from "../../@lib/icons";
import { useLocation } from "react-router-dom";
import { useLanguageTranslator } from "../useLanguageContext";
import I18nSelect from "../@common/I18nSelect";

function Navbar() {
  const location = useLocation();
  const { translator } = useLanguageTranslator();

  const { user, logoutUser } = useAuthSession() as any;

  const pages = [
    { title: translator("navbar.Home"), path: "#" },
    { title: translator("navbar.About Us"), path: "#about-us" },
    { title: translator("navbar.Our Focus"), path: "#our-focus" },
    { title: translator("navbar.FAQ"), path: "#FAQ" },
    {
      title: translator("landingPage.Navigating the Niyel Tracker"),
      path: "#step-by-step-guide",
    },
  ];
  const settings = [
    { title: translator("Dashboard"), path: "/dashboard" },
    { title: translator("navbar.Logout"), path: "/logout" },
  ];

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const firstLetter = user?.firstName?.charAt(0) || "";

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "white" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            // href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <Link to="/">
              <AppLogo size="medium" />
            </Link>
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <ConditionalRenderer condition={anchorElNav === null}>
                <CollapseNavbarIcon />
              </ConditionalRenderer>
              <ConditionalRenderer condition={anchorElNav !== null}>
                <CrossNavbarIcon />
              </ConditionalRenderer>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {pages.map((page) => (
                <Button
                  key={page?.title}
                  href={page?.path}
                  onClick={handleCloseNavMenu}
                  sx={{
                    display: "block",
                    color:
                      location.hash === page.path ||
                      (!location.hash && page.path === "#")
                        ? "#00AAB0"
                        : "black",
                    fontWeight:
                      location.hash === page.path ||
                      (!location.hash && page.path === "#")
                        ? "bold"
                        : "normal",
                  }}
                >
                  {page?.title}
                </Button>
              ))}
              {/* // <MenuItem key={page?.title} href={page?.path} onClick={handleCloseNavMenu}>
              //   <Typography sx={{ textAlign: "center", color: "black" }}>
              //     {page?.title}
              //   </Typography>
              // </MenuItem> */}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <AppLogo size="medium" />
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: { md: "center" },
            }}
          >
            {pages.map((page) => (
              <Button
                key={page?.title}
                href={page?.path}
                onClick={handleCloseNavMenu}
                style={{
                  display: "block",
                  color:
                    location.hash === page.path ||
                    (!location.hash && page.path === "#")
                      ? "#00AAB0"
                      : "black",
                  fontWeight:
                    location.hash === page.path ||
                    (!location.hash && page.path === "#")
                      ? "bold"
                      : "500",
                  minWidth: "0px",
                }}
              >
                {page?.title}
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
              <I18nSelect
                options={[
                  { label: translator("English"), value: "en" },
                  { label: translator("French"), value: "fr" },
                  { label: translator("Portuguese"), value: "pt" },
                ]}
              />
            <ConditionalRenderer condition={!user}>
              <Link
                to="/auth/login"
                style={{
                  backgroundColor: "#F6A000",
                  padding: "8px 25px",
                  color: "white",
                  borderRadius: "10px",
                  fontSize: "14px",
                  marginTop: "13px",
                  textDecoration: "none",
                }}
              >
                {translator("LOG IN")}
              </Link>
            </ConditionalRenderer>
            <ConditionalRenderer condition={!!user}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt={firstLetter} src="/static/images/avatar/2.jpg" />
                </IconButton>
              </Tooltip>
            </ConditionalRenderer>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting?.path} onClick={handleCloseUserMenu}>
                  <Link
                    to={setting?.path === "/logout" ? "" : setting?.path}
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={() =>
                      setting?.path === "/logout" ? logoutUser() : () => {}
                    }
                  >
                    <Typography sx={{ textAlign: "center" }}>
                      {setting?.title}
                    </Typography>
                  </Link>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export { Navbar };
